import React from "react";


function Heading(){
    return <header>
       <h1>NoteKeeper</h1>
    </header>
}

export default Heading;